import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.content_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.aboutMd_1 = aboutMd;
        this.connectSuccessMd_1 = connectSuccessMd;
        this.contributionStartMd_1 = contributionStartMd;
        this.boostMd_1 = boostMd;
        this.recentInfoMd_1 = recentInfoMd;
        this.installSuccessMd_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.aboutMd_1 + ', connectSuccessMd=' + this.connectSuccessMd_1 + ', contributionStartMd=' + this.contributionStartMd_1 + ', boostMd=' + this.boostMd_1 + ', recentInfoMd=' + this.recentInfoMd_1 + ', installSuccessMd=' + this.installSuccessMd_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.aboutMd_1);
        result = imul(result, 31) + getStringHashCode(this.connectSuccessMd_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.contributionStartMd_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.boostMd_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.recentInfoMd_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.installSuccessMd_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.aboutMd_1 === other.aboutMd_1))
          return false;
        if (!(this.connectSuccessMd_1 === other.connectSuccessMd_1))
          return false;
        if (!(this.contributionStartMd_1 === other.contributionStartMd_1))
          return false;
        if (!(this.boostMd_1 === other.boostMd_1))
          return false;
        if (!(this.recentInfoMd_1 === other.recentInfoMd_1))
          return false;
        if (!(this.installSuccessMd_1 === other.installSuccessMd_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstance21oyq66lfgb66,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
